export const ServiceCalendarNav = {
  CalendarMonth: 'calendar-month',
} as const;
